export function formatFilmClock(seconds) {
  const safe = Math.max(0, Math.floor(Number.isFinite(seconds) ? seconds : 0));
  return `${Math.floor(safe / 60)}:${String(safe % 60).padStart(2, "0")}`;
}

export default function FilmConsole({
  clock = 0,
  duration = 0,
  playing = false,
  record = false,
  onToggle,
  onStop,
  onSeek,
  onSkip,
  volume,
  onVolume,
  muted,
  onMute,
  speed,
  onSpeed,
  speeds,
  onFs,
  fs,
  downloadHref,
}) {
  const max = duration || 0;

  return (
    <div className={`film-console${record ? " is-record" : ""}`}>
      <div className="film-console__scrub">
        <button type="button" className="film-console__play" onClick={onToggle} aria-label={playing ? "Pause" : "Play"}>
          {playing ? "Pause" : "Play"}
        </button>
        <span className="film-console__time">
          {formatFilmClock(clock)}
          <i>/</i>
          {formatFilmClock(max)}
        </span>
        <input
          type="range"
          min="0"
          max={max || 0}
          step="0.1"
          value={Math.min(clock, max) || 0}
          aria-label="Position"
          onChange={(event) => onSeek?.(Number(event.target.value))}
        />
      </div>
      <div className="film-console__row">
        {onSkip ? (
          <>
            <button type="button" onClick={() => onSkip(-10)}>
              −10s
            </button>
            <button type="button" onClick={() => onSkip(10)}>
              +10s
            </button>
          </>
        ) : null}
        {onVolume ? (
          <label className="film-console__vol">
            Vol
            <input
              type="range"
              min="0"
              max="1"
              step="0.05"
              value={muted ? 0 : volume}
              onChange={(event) => onVolume(Number(event.target.value))}
            />
          </label>
        ) : null}
        {onMute ? (
          <button type="button" onClick={onMute}>
            {muted ? "Unmute" : "Mute"}
          </button>
        ) : null}
        {onSpeed && speeds ? (
          <label>
            Speed
            <select value={speed} onChange={(event) => onSpeed(Number(event.target.value))}>
              {speeds.map((item) => (
                <option key={item} value={item}>
                  {item}×
                </option>
              ))}
            </select>
          </label>
        ) : null}
        {onFs ? (
          <button type="button" onClick={onFs}>
            {fs ? "Return" : "Full frame"}
          </button>
        ) : null}
        {downloadHref ? (
          <a href={downloadHref} download="REChecklist-DreamHome-Journey.mp4">
            Download
          </a>
        ) : null}
        {onStop ? (
          <button type="button" onClick={onStop}>
            Stop
          </button>
        ) : null}
      </div>
    </div>
  );
}
